import {
  vArray,
  vBoolStrict,
  vEmail,
  vObject,
  vObjectId,
  vOptional,
  vOptionalDef,
  type vOutput,
  vPartial,
  vPicklist,
  vPostalCode,
  vString,
} from '../validation/index.ts'
import { billToSchema } from './account-bill-to.ts'
import { apiQuoteRequestSchema } from './api-quote-request.ts'
import { paymentTerms } from './common.ts'
import { baseCustomsBrokerSchema } from './customs-broker.ts'
import { emergencyContactSchema } from './emergency-contact.ts'

export const customerRoutedBillToSchema = vObject({
  ...vPartial(billToSchema).entries,
  postalCode: vPostalCode(),
})

export const createCustomerRoutedLoadSchema = vObject({
  ...apiQuoteRequestSchema.entries,
  carrierId: vObjectId(),
  createBOL: vOptionalDef(vBoolStrict(), true),
  customsBroker: vOptional(vArray(baseCustomsBrokerSchema)),
  emergencyContact: vOptional(emergencyContactSchema),
  schedulePickup: vOptionalDef(vBoolStrict(), true),
  serviceId: vOptional(vString()),
  bolNumber: vOptional(vString()),
  billTo: vOptional(customerRoutedBillToSchema),
  paymentTerms: vOptional(vPicklist(paymentTerms)),
  spotQuoteContactEmail: vOptional(vEmail),
})

export type CustomerRoutedBillTo = vOutput<typeof customerRoutedBillToSchema>
export type CreateCustomerRoutedLoadDTO = vOutput<
  typeof createCustomerRoutedLoadSchema
>
